import { createFileRoute } from '@tanstack/react-router';
import OrganizationSettingsTemplate from '@/features/agent/organizations/templates/OrganizationSettingsTemplate';

type SettingsSearch = {
  t?: 'general' | 'portal' | 'account' | 'members' | 'api';
  st?: 'api' | 'ai';
};

export const Route = createFileRoute('/agent/settings/')({
  component: RouteComponent,
  staticData: { title: '設定' },
  validateSearch: (search: Record<string, unknown>): SettingsSearch => {
    const t = search.t;
    const st = search.st;

    return {
      t:
        t === 'general' || t === 'portal' || t === 'account' || t === 'members' || t === 'api'
          ? t
          : undefined,
      st: st === 'api' || st === 'ai' ? st : undefined,
    };
  },
});

function RouteComponent() {
  return (
    <div>
      <OrganizationSettingsTemplate />
    </div>
  );
}
